import React from "react";
import { BsDownload, BsFileEarmarkPdf, BsShieldCheck } from "react-icons/bs";
import "./nirf.css";

const defaultReports = [
  { label: "A.Y. 2025-26", href: "/pdf/Home/NIRF/A.Y. 2025-26.pdf" },
  { label: "A.Y. 2024-25", href: "/pdf/Home/NIRF/A.Y. 2024-25.pdf" },
  { label: "A.Y. 2023-24", href: "/pdf/Home/NIRF/A.Y. 2023-24.pdf" },
  { label: "A.Y. 2022-23", href: "/pdf/Home/NIRF/A.Y. 2022-23.pdf" },
  { label: "A.Y. 2021-22", href: "/pdf/Home/NIRF/A.Y. 2021-22.pdf" },
  { label: "A.Y. 2020-21", href: "/pdf/Home/NIRF/A.Y. 2020-21 (2).pdf" },
  { label: "A.Y. 2019-20", href: "/pdf/Home/NIRF/A.Y. 2019-20.pdf" },
];

function NirfLogo({ logoSrc }) {
  return <img className="nirf-logo-img" src={logoSrc} alt="NIRF" />;
}

function Nirf({
  reports = defaultReports,
  logoSrc = "/Website_Assets/main-logo.png",
  className = "",
}) {
  
  // This function forces a download specifically when the download icon is clicked
  const handleDownload = (e, href, label) => {
    e.preventDefault(); // Stops the click from opening the PDF in a new tab
    e.stopPropagation(); // Prevents the click from bubbling up to the main card
    
    // Create a temporary hidden link to trigger the download
    const tempLink = document.createElement("a");
    tempLink.href = href;
    tempLink.setAttribute("download", `${label}.pdf`); 
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
  };

  return (
    <section className={`nirf-section ${className}`} aria-labelledby="nirf-heading">
      <div className="nirf-card">
        <div className="nirf-left-panel">
          <div className="nirf-logo-circle">
            <NirfLogo logoSrc={logoSrc} />
          </div>
          <p>National Institutional Ranking Framework</p>
        </div>

        <div className="nirf-content">
          <div className="nirf-pattern" aria-hidden="true" />

          <header className="nirf-header">
            <h2 id="nirf-heading">
              NIRF <span>Data</span>
            </h2>
            <p>
              Access our institutional data submitted to NIRF, Ministry of
              Education, Government of India.
            </p>
          </header>

          <div className="nirf-report-grid" aria-label="NIRF academic year reports">
            {reports.map((report) => {
              return report.href ? (
                <a
                  className="nirf-report-card"
                  href={report.href}
                  key={report.label}
                  target="_blank" // Clicking anywhere on the card opens in a NEW TAB
                  rel="noreferrer"
                  // Removed the global 'download' attribute from here
                >
                  <BsFileEarmarkPdf className="nirf-pdf-icon" aria-hidden="true" />
                  <span>{report.label}</span>
                  
                  {/* Download Icon with specific click handler */}
                  <BsDownload 
                    className="nirf-download-icon" 
                    aria-hidden="true"
                    title="Download PDF"
                    onClick={(e) => handleDownload(e, report.href, report.label)} 
                  />
                </a>
              ) : (
                <button className="nirf-report-card" type="button" key={report.label}>
                  <BsFileEarmarkPdf className="nirf-pdf-icon" aria-hidden="true" />
                  <span>{report.label}</span>
                  <BsDownload className="nirf-download-icon" aria-hidden="true" />
                </button>
                
              );
            })}
          </div>

          <div className="nirf-approval">
            <BsShieldCheck aria-hidden="true" />
            <span>
              Approved data submitted to Ministry of Education, Government of India
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Nirf;